<template>
  <div class="distributionTile" :class="{ 'distributionTile--active': active }">
    <div class="distributionTile__header">
      <Icon :icon="icon" class="distributionTile__icon" />
      <h4 class="distributionTile__title" v-if="!active">
        {{ title.charAt(0).toUpperCase() + title.slice(1) }}
      </h4>
    </div>
    <div class="distributionTile__content">
      <div class="distributionTile__body">
        <h4 v-if="active" class="distributionTile__title">
          {{ title }}
        </h4>
        <p>{{ description }}</p>
      </div>
      <div class="distributionTile__footer">
        <slot name="button"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '@/components/Icon.vue';

export default {
  name: 'DistributionTile',
  components: {
    Icon,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
